module.exports = __webpack_public_path__ + "img/17.ef98f04e.jpg";